"use client";
import * as React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { FilledForm } from "./types";

interface ActivityCardProps {
  avatar: string;
  title: string;
  name: string;
  phone: string;
  product: string;
  activities: string;
  time: string;
  filledForms?: FilledForm[];
}

export const ActivityCard: React.FC<ActivityCardProps> = ({
  avatar,
  title,
  name,
  phone,
  product,
  activities,
  time,
  setSelectClient,
  filledForms = [],
}) => {
  const navigate = useNavigate();

  const handleFormClick = (formId: string) => {
    navigate(`/filled-forms/view/${formId}`);
  };

  console.log("Whatsapp:", phone);

  return (
    <CardContainer
      style={{
        backgroundColor: "white",
        boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
      }}
    >
      <CardHeader>
        <Avatar src={avatar} alt="User avatar" />
        <HeaderInfo>
          <Title>{title}</Title>
          <Subtitle>{name}</Subtitle>
        </HeaderInfo>
      </CardHeader>

      {/* {filledForms && filledForms.length > 0 && (
        <FilledFormsSection>
          <Label>Formulários Preenchidos</Label>
          <FilledFormsList>
            {filledForms.map((form) => (
              <FormItem 
                key={form._id}
                onClick={() => handleFormClick(form._id)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    handleFormClick(form._id);
                  }
                }}
              >
                <FormIcon
                  src="https://cdn.builder.io/api/v1/image/assets/a957b64922e04ac2a23d8b53cd42fbd2/846e52a905d2261abca8971efbf21912c96769ac?placeholderIfAbsent=true"
                  alt="Form icon"
                />
                <FormName>{form.phaseFormName}</FormName>
              </FormItem>
            ))}
          </FilledFormsList>
        </FilledFormsSection>
      )} */}

      <CardDetails>
        <InfoColumnsWrapper>
          <ProductColumn>
            <Label>Produto</Label>
            <Value style={{ fontSize: 15 }}>{product}</Value>
          </ProductColumn>

          <ActivitiesColumn>
            <Label>Atividades</Label>
            <ActivitiesWrapper>
              <Value style={{ fontSize: 15 }}>{activities}</Value>
              <ActivityIcon
                onClick={() => {
                  setSelectClient();
                }}
                style={{ cursor: "pointer" }}
                className="hover:bg-gray-50"
                src="https://cdn.builder.io/api/v1/image/assets/a957b64922e04ac2a23d8b53cd42fbd2/846e52a905d2261abca8971efbf21912c96769ac?placeholderIfAbsent=true"
                alt="Activity icon"
              />
            </ActivitiesWrapper>
          </ActivitiesColumn>

          <TimeColumn>
            <Label>Tempo</Label>
            <Value>{time}</Value>
          </TimeColumn>

          <WhatsappButton>
            <WhatsappIcon
              src="https://cdn.builder.io/api/v1/image/assets/a957b64922e04ac2a23d8b53cd42fbd2/d28b6f950274f74275b47f8dbd93d85bf92f40a0?placeholderIfAbsent=true"
              alt="WhatsApp"
            />
          </WhatsappButton>
        </InfoColumnsWrapper>
      </CardDetails>
    </CardContainer>
  );
};

const CardContainer = styled.article`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 14px;
  background-color: #fcfcfc;
  min-height: 85px;
  width: 100%;
  padding: 20px 30px;
  overflow: hidden;
  min-width: 900px;
`;

const CardHeader = styled.header`
  display: flex;
  flex: 1;
  align-items: center;
  gap: 18px;
  font-family: Inter, -apple-system, Roboto, Helvetica, sans-serif;
  @media (max-width: 991px) {
    width: 100%;
  }
`;

const Avatar = styled.img`
  width: 50px;
  height: 50px;
  aspect-ratio: 1;
  object-fit: contain;
  border: 2px solid #1777cf;
  border-radius: 100px;
  border-right: 1px solid lightgrey;
`;

const HeaderInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  overflow: hidden;
`;

const Title = styled.h3`
  color: #3a3f51;
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Subtitle = styled.p`
  color: #91929e;
  font-size: 14px;
  margin: 0;
`;

const CardDetails = styled.div`
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  justify-content: space-between;
`;

const InfoColumnsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  justify-content: space-between;
`;

const ProductColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 200px;
  overflow: hidden;
  @media (max-width: 991px) {
    width: 100%;
  }
`;

const ActivitiesColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 110px;
  @media (max-width: 991px) {
    width: calc(50% - 10px);
  }
`;

const TimeColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 70px;
  text-align: right;
  @media (max-width: 991px) {
    width: calc(50% - 10px);
    text-align: left;
  }
`;

const ActivitiesWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Label = styled.span`
  color: #91929e;
  font-family: Inter, -apple-system, Roboto, Helvetica, sans-serif;
  font-size: 14px;
  font-weight: 400;
`;

const Value = styled.span`
  color: #3a3f51;
  font-family: Inter, -apple-system, Roboto, Helvetica, sans-serif;
  font-size: 16px;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ActivityIcon = styled.img`
  width: 24px;
  height: 19px;
  object-fit: contain;
`;

const WhatsappButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1;
  border-radius: 8px;
  background-color: #f4f4f4;
  border: none;
  width: 42px;
  height: 42px;
  cursor: pointer;
  flex-shrink: 0;
  @media (min-width: 992px) {
    margin-right: 10px;
  }
`;

const WhatsappIcon = styled.img`
  width: 15px;
  aspect-ratio: 1;
  object-fit: contain;
`;

const FilledFormsSection = styled.div`
  margin: 0 0 15px 68px; /* 68px to align with the title (50px avatar + 18px gap) */
  width: calc(100% - 68px);
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
  @media (max-width: 991px) {
    margin: 0 0 15px 0;
    width: 100%;
  }
`;

const FilledFormsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 6px;
`;

const FormItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  background-color: #f5f9ff;
  border-radius: 4px;
  border: 1px solid #e6f0ff;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: #e6f0ff;
    border-color: #cce0ff;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(66, 153, 225, 0.2);
  }

  &:active {
    transform: translateY(1px);
  }
`;

const FormIcon = styled.img`
  width: 14px;
  height: 14px;
  object-fit: contain;
`;

const FormName = styled.span`
  color: #3a3f51;
  font-size: 13px;
  font-weight: 500;
`;
